import { CopyToClipboard } from "react-copy-to-clipboard"
import { ToastContainer, toast } from "react-toastify";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter"
import { 
    dark, darcula, nightOwl,
    dracula, coy, okaidia, nord, 
    solarizedDarkAtom, atomDark } from "react-syntax-highlighter/dist/esm/styles/prism"

interface codeFormatter {
    codeSnippet: string;
    lang?: string;
    
}
const CodeFormatter = ({codeSnippet, lang="cpp"}: codeFormatter) => {
    const handleCopy = () => {
        const toastId: string = "myToast"
        if(!toast.isActive(toastId)){
        toast.success("code Copied!", {
            toastId,
            autoClose: 1500,
            pauseOnHover: false,

        })
    }
    }
   
    return (
        <div className="code-container">
           <SyntaxHighlighter language={lang}  style={nightOwl} customStyle={{borderRadius: "14px"}}>
                {codeSnippet}
            </SyntaxHighlighter>
            <CopyToClipboard text={codeSnippet} onCopy={handleCopy}>
                <button className="copy-button">c</button>
            </CopyToClipboard> 
            <ToastContainer limit={1}/>
        </div>
    )
}

export default CodeFormatter
